const INIT_FILTER_VALUE = {
  national_id: null,
  full_name: null,
  address: {
    amphur: null,
    province: null,
    tumbol: null,
    village: null,
  },
  defaultAddress: {
    amphur: null,
    province: null,
    tumbol: null,
  },
  end_age: null,
  start_age: null,
  survey_status: null,
  end_date: null,
  start_date: null,
  address_number: null,
  is_verified_cwd: null
};

const state = () => {
  return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
  setProvince({ commit }, province) {
    commit("setProvince", province);
  },
  clearStore({ commit }) {
    commit("clearStore");
  },
  setStore({ commit }, store) {
    commit("setStore", store);
  },
  setDefaultAddress({ commit }, data) {
    commit("setDefaultAddress", data);
  },
};

// mutations
const mutations = {
  setProvince(state, province) {
    state.address.province = province;
  },
  clearStore(state) {
    state = { ...INIT_FILTER_VALUE };
  },
  setStore(state, store) {
    Object.assign(state, store);
  },
  setDefaultAddress(state, data) {
    Object.assign(state.defaultAddress, data);
  }
};

// getters
const getters = {
  province: (state) => state.address.province,
  getAllFilter: (state) => {
    return state;
  },
  getFilterSummary: (state) => {
    let result = [];

    const province = state.address.province || state.defaultAddress.province;
    const amphur = state.address.amphur || state.defaultAddress.amphur;
    const tumbol = state.address.tumbol || state.defaultAddress.tumbol;

    if (province){
      result.push(province.province_name)
    }
    if (amphur){
      result.push(amphur.amphur_name)
    }
    if (tumbol){
      result.push(tumbol.tumbol_name)
    }
    if (state.address.village){
      result.push(state.address.village.village_name)
    }
    if (state.address_number){
      result.push(`บ้านเลขที่ ${state.address_number}`)
    }
    if (state.start_date || state.end_date){
      if(state.start_date){
        let start_format = new Date(state.start_date)
        start_format = [String(start_format.getDate()).padStart(2, '0'),
                        String(start_format.getMonth() + 1).padStart(2, '0'),
                        start_format.getFullYear() + 543
                      ].join('/')
        result.push(`วันที่ ${start_format}`)
        if(state.end_date){
          let end_format = new Date(state.end_date)
          end_format = [String(end_format.getDate()).padStart(2, '0'),
                        String(end_format.getMonth() + 1).padStart(2, '0'),
                        end_format.getFullYear() + 543
                      ].join('/')
          result.push(`ถึง ${end_format}`)
        }
      }
    }
    if (state.national_id){
      result.push(`${state.national_id}`)
    }
    if (state.full_name){
      result.push(`ชื่อ ${state.full_name}`)
    }
    if(state.start_age >= 0 && typeof state.start_age == "number"){
      result.push(`อายุ ${state.start_age}`)
    }
    if(state.end_age >= 0 && typeof state.end_age == "number" && state.start_age >= 0 && typeof state.start_age == "number"){
      result.push(`ถึง ${state.end_age}`)
    }
    if (state.survey_status != null){
      result.push(`สถานะ ${state.survey_status ? "สำรวจแล้ว" : "ยังไม่สำรวจ"}`)
    }
    if (state.is_verified_cwd != null){
      result.push(`สถานะตรวจสอบ ${state.is_verified_cwd ? "ตรวจสอบแล้ว" : "ยังไม่ตรวจสอบ"}`)
    }

    return result;
  },
  getFilterForApi: (state, getters, rootState, rootGetters) => {
    const result = {};
    if ((rootGetters["userAuth/getUserProvinceCode"].length === 2 && rootGetters["userAuth/getUserProvinceCode"] !== "00") || state.address.province)
      result.province_ID = state.address.province ? state.address.province._id.province_ID: Number(rootGetters["userAuth/getUserProvinceCode"])
    if (rootGetters["userAuth/getUserAmphurCode"].length === 4 || state.address.amphur)
      result.amphur_ID = state.address.amphur ? state.address.amphur._id.amphur_ID : Number(rootGetters["userAuth/getUserAmphurCode"]);
    if (rootGetters["userAuth/getUserTumbolCode"].length === 6 || state.address.tumbol)
      result.tambol_ID = state.address.tumbol ? state.address.tumbol._id.tumbol_ID : Number(rootGetters["userAuth/getUserTumbolCode"]);
    if (state.address.village)
      result.village_ID = state.address.village._id.village_ID;
    if (state.full_name) result.full_name = state.full_name;
    if (state.national_id) result.NID = state.national_id;
    if (typeof state.start_age == "number" && state.start_age >= 0) result.start_age = state.start_age;
    if (typeof state.end_age == "number" && state.end_age >= 0) result.end_age = state.end_age;
    if (state.survey_status != null) result.neet_survey = state.survey_status;
    if (state.address_number) result.address_num = state.address_number;
    if (state.start_date) result.survey_start_date = state.start_date;
    if (state.end_date) result.survey_end_date = state.end_date;
    if (state.is_verified_cwd != null) result.is_verified_cwd = state.is_verified_cwd;

    return result;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
